import { render, staticRenderFns } from "./BarraganModal.vue?vue&type=template&id=e8174702&scoped=true&"
import script from "./BarraganModal.vue?vue&type=script&lang=js&"
export * from "./BarraganModal.vue?vue&type=script&lang=js&"
import style0 from "./BarraganModal.vue?vue&type=style&index=0&id=e8174702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8174702",
  null
  
)

export default component.exports